import React from "react";
import styles from "./styles/style.module.scss";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const LinkCard = ({ cardData }) => {
    const { svg, text, to } = cardData;
    return (
        <Col xxl={3} xl={3} lg={4} md={6} sm={6} xs={6}>
            <div className={styles["link-card"]}>
                <Link to={to}>
                    <div className="card-container">
                        <div className="overlay">
                            <div className="icon">{svg}</div>
                            <h4 className="text">
                                <FormattedMessage id={text} />
                            </h4>
                            <div className="bg-icon">{svg}</div>
                        </div>
                    </div>
                </Link>
            </div>
        </Col>
    );
};

export default LinkCard;
